import i18next from "i18next"
import { equals } from "ramda"
import { int2HexWithPrefix } from "../../Common/Utils/Numbers"

export const dataAnalyticsSignalId = ({ signalName, busName, messageName, messageAddress }) => `${signalName}-${busName}-${messageName}-${messageAddress}`
export const dataAnalyticsSignalName = (signal) => {
  let res = signal.signalName
  if (signal.busName) {
    res += ` - ${signal.busName}`
  }
  if (signal.messageName) {
    res += ` - ${signal.messageName}`
  }
  if (signal.messageAddress !== 0) {
    res += `(${int2HexWithPrefix(signal.messageAddress)})`
  }

  return res
}

export const queryTypes = {
  'EXTENDED': i18next.t('data:ui.Extended'),
  'FILTER': i18next.t('data:ui.Filter'),
  'PERIOD': i18next.t('data:ui.Period'),
}

export const isExtendedQueryType = equals('EXTENDED')
export const isFilterQueryType = equals('FILTER')
export const isPeriodQueryType = equals('PERIOD')
